var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"skill-descript"}},[_c('div',{staticClass:"talking-box"},[_c('div',{staticClass:"talk-text"},[_vm._v(_vm._s(_vm.skill.descript))])])])}
var staticRenderFns = []

export { render, staticRenderFns }